import React from "react";
import { Check, ArrowRight } from "lucide-react";

export default function FeatureGridItem2({ d }) {
  switch (d.variant) {
    case "fork-community":
      return (
        <div className="flex p-8 rounded-xl flex-col bg-white transition-all duration-300 shadow-lg hover:shadow-xl" style={{ backgroundColor: "#ffffff" }}>
          <h3 className="text-2xl font-bold tracking-tight" style={{ color: "#0f172a" }}>
            {d.title}
          </h3>
          <p className="mt-4 text-sm leading-relaxed min-h-[56px]" style={{ color: "#334155" }}>
            {d.description}
          </p>
          
          <ul className="mt-6 space-y-3.5 text-sm flex-1" role="list">
            <li className="flex items-center gap-3" style={{ color: "#1e293b" }}>
              <Check size={18} className="text-emerald-600 shrink-0" />
              <span style={{ color: "#1e293b" }}>One application threat model</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#1e293b" }}>
              <Check size={18} className="text-emerald-600 shrink-0" />
              <span style={{ color: "#1e293b" }}>Single user access</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#1e293b" }}>
              <Check size={18} className="text-emerald-600 shrink-0" />
              <span style={{ color: "#1e293b" }}>STRIDE Catalog &amp; OVAL ingestion</span>
            </li>
          </ul>

          <a 
            href="/signup" 
            className="tfl-btn-light mt-8 inline-flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold text-sm border border-slate-200 bg-white hover:bg-slate-50 transition-all"
            style={{ color: "#0f172a", backgroundColor: "#ffffff", borderColor: "#e2e8f0" }}
          >
            <span style={{ color: "#0f172a" }}>Get Started Free</span>
            <ArrowRight size={15} />
          </a>
        </div>
      );

    case "fork-enterprise":
      return (
        <div className="flex p-8 rounded-xl flex-col bg-gradient-to-b from-[#f5f3ff] via-white to-slate-50 shadow-xl shadow-[#7c3aed]/10 relative transition-all duration-300">
          <h3 className="tfl-price-featured-title text-2xl font-bold tracking-tight" style={{ color: "#6d28d9" }}>
            {d.title}
          </h3>
          <p className="mt-4 text-sm leading-relaxed min-h-[56px]" style={{ color: "#334155" }}>
            {d.description}
          </p>

          <ul className="mt-6 space-y-3.5 text-sm flex-1" role="list">
            <li className="flex items-center gap-3" style={{ color: "#0f172a" }}>
              <Check size={18} className="text-[#7c3aed] shrink-0" />
              <span style={{ color: "#0f172a" }}>Unlimited threat models &amp; workspaces</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#0f172a" }}>
              <Check size={18} className="text-[#7c3aed] shrink-0" />
              <span style={{ color: "#0f172a" }}>Unlimited team members &amp; RBAC</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#0f172a" }}>
              <Check size={18} className="text-[#7c3aed] shrink-0" />
              <span style={{ color: "#0f172a" }}>Full Sentry 2.0 AI assistant access</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#0f172a" }}>
              <Check size={18} className="text-[#7c3aed] shrink-0" />
              <span style={{ color: "#0f172a" }}>Access to all AppSec integrations</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#0f172a" }}>
              <Check size={18} className="text-[#7c3aed] shrink-0" />
              <span style={{ color: "#0f172a" }}>SSO with SAML or OIDC</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#0f172a" }}>
              <Check size={18} className="text-[#7c3aed] shrink-0" />
              <span style={{ color: "#0f172a" }}>Audit logs &amp; compliance export</span>
            </li>
          </ul>

          <a 
            href="/book-demo" 
            className="tfl-btn-primary mt-8 inline-flex items-center justify-center gap-2 py-3 px-4 rounded-lg text-white font-semibold text-sm bg-[#7c3aed] hover:bg-[#6d28d9] shadow-md shadow-[#7c3aed]/30 transition-all"
            style={{ color: "#ffffff", backgroundColor: "#7c3aed" }}
          >
            <span style={{ color: "#ffffff" }}>Contact sales</span>
            <ArrowRight size={15} />
          </a>
        </div>
      );

    case "fork-enterprise-pt":
      return (
        <div className="flex p-8 rounded-xl flex-col bg-white transition-all duration-300 shadow-lg hover:shadow-xl" style={{ backgroundColor: "#ffffff" }}>
          <h3 className="text-2xl font-bold tracking-tight" style={{ color: "#0f172a" }}>
            {d.title}
          </h3>
          <p className="mt-4 text-sm leading-relaxed min-h-[56px]" style={{ color: "#334155" }}>
            Extend your ThreatForge subscription with managed security testing.
          </p>

          <ul className="mt-6 space-y-3.5 text-sm flex-1" role="list">
            <li className="flex items-center gap-3" style={{ color: "#1e293b" }}>
              <Check size={18} className="text-emerald-600 shrink-0" />
              <span style={{ color: "#1e293b" }}>Everything from ThreatForge Enterprise</span>
            </li>
            <li className="flex items-start gap-3" style={{ color: "#1e293b" }}>
              <Check size={18} className="text-emerald-600 shrink-0 mt-0.5" />
              <span style={{ color: "#1e293b" }}>Request on-demand security testing directly from your application threat models</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#1e293b" }}>
              <Check size={18} className="text-emerald-600 shrink-0" />
              <span style={{ color: "#1e293b" }}>In-depth exploitability &amp; attack tree analysis</span>
            </li>
            <li className="flex items-center gap-3" style={{ color: "#1e293b" }}>
              <Check size={18} className="text-emerald-600 shrink-0" />
              <span style={{ color: "#1e293b" }}>Real-time status updates</span>
            </li>
          </ul>

          <a 
            href="/book-demo" 
            className="tfl-btn-light mt-8 inline-flex items-center justify-center gap-2 py-3 px-4 rounded-lg font-semibold text-sm border border-slate-200 bg-white hover:bg-slate-50 transition-all"
            style={{ color: "#0f172a", backgroundColor: "#ffffff", borderColor: "#e2e8f0" }}
          >
            <span style={{ color: "#0f172a" }}>Contact sales</span>
            <ArrowRight size={15} />
          </a>
        </div>
      );

    default:
      return null;
  }
}





